/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Article } from '../../models/article';

export interface ApiMasterArticleGetActiveGet$Params {
}

export function apiMasterArticleGetActiveGet(http: HttpClient, rootUrl: string, params?: ApiMasterArticleGetActiveGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Article>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterArticleGetActiveGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Article>>;
    })
  );
}

apiMasterArticleGetActiveGet.PATH = '/api/Master/Article/GetActive';
